import React, { useContext, useState } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Persistent banner while a superuser is viewing the app as another user.
 */
const ImpersonationBanner = () => {
  const { user, exitImpersonation } = useContext(AuthContext);
  const { colors } = useTheme();
  const [exiting, setExiting] = useState(false);

  if (!user?.impersonating) {
    return null;
  }

  const targetLabel = user.email || `user #${user.id}`;
  const actorLabel = user.actor?.email || 'admin';
  const bg = colors.warning || colors.orange;
  const fg = colors.bgPrimary || '#111';

  const handleExit = async () => {
    if (exiting || !exitImpersonation) return;
    setExiting(true);
    try {
      await exitImpersonation();
    } catch (_) {
      setExiting(false);
    }
  };

  return (
    <div
      role="status"
      style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        flexWrap: 'wrap',
        padding: '8px 14px',
        backgroundColor: bg,
        color: fg,
        fontSize: '0.875rem',
        fontWeight: 600,
        borderBottom: `1px solid ${colors.border}`,
        zIndex: 1100,
      }}
    >
      <span>
        Viewing as {targetLabel}
        <span style={{ fontWeight: 400, opacity: 0.9 }}>
          {' '}
          (read-only · signed in as {actorLabel})
        </span>
      </span>
      <button
        type="button"
        onClick={handleExit}
        disabled={exiting}
        style={{
          border: `1px solid ${fg}`,
          background: 'transparent',
          color: fg,
          borderRadius: 4,
          padding: '3px 10px',
          fontSize: '0.875rem',
          fontWeight: 600,
          cursor: exiting ? 'wait' : 'pointer',
        }}
      >
        {exiting ? 'Exiting…' : 'Exit'}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
